import React from "react";
import PdfLayout from '../PdfLayout';
import PdfLayoutWidget from './PdfLayoutWidget';
import { Screen } from '../../services';

/** Class representing a PDF layout image widget. */
class LineWidget extends PdfLayoutWidget {

    constructor(properties) {
        super({
            ...(LineWidget.getDefaultOptions()),
            ...properties,
            type: PdfLayout.SHAPE,
            subType: PdfLayout.LINE
        });
    }

    /**
     * Get this widget default options
     */
    static getDefaultOptions() {
        return {
            position: {x: 2,y: 2},
            dimensions: {height: Screen.pxToCm(1), width: 5},
            transform: { rotation: 0 },
            options: {
                style: {
                    borderStyle: 'solid',
                    borderWidth: 1,
                    borderColor: '#000000'
                }
            }
        };
    }

    /**
     * Return the list of options this widget handles
     */
    getHandledOptions() {
        return [
            PdfLayout.OPTION_X,
            PdfLayout.OPTION_Y,
            PdfLayout.OPTION_Z,
            PdfLayout.OPTION_WIDTH,
            PdfLayout.OPTION_ROTATION,
            PdfLayout.OPTION_BORDER_COLOR,
            PdfLayout.OPTION_BORDER_STYLE,
            PdfLayout.OPTION_BORDER_WIDTH
        ];
    }

    /**
     * Return this widget preview as JSX string
     *
     * @param {Object} props with at least the following properties:
     *                 - {Bool} inEdition
     *                 - {String} lang
     *                 - {Object} setting
     */
    getPreview(props) {
        const { inEdition } = props;

        return (
            <div style={{
                top: Screen.cmToPx(this.position.y),
                left: Screen.cmToPx(this.position.x),
                width: Screen.cmToPx(this.dimensions.width),
                height: this.dimensions.height,
                borderBottom: `${this.options?.style?.borderWidth}px ${this.options?.style?.borderStyle} ${this.options?.style?.borderColor}`
            }} />
        );
    }

    /**
     * Return the icon to use on the editor button
     */
    getIcon() {
        return 'arrows-h';
    }

    /**
     * Is this widget resizable ?
     **/
    isResizable = () => false;

    /**
     * Is this widget resizable only horizontally ?
     **/
    isResizableHorizontallyOnly = () => true;
}

export default LineWidget;
